<template>
  <div class="p-message-preview-list__item p-message-preview-list__item--desktop is-active">
    <div class="p-message-preview__image">
      <img :src="largeImageUrl" />
    </div>
    <div class="p-message-preview__icon">
      <img :src="iconUrl" />
    </div>
    <div class="p-message-preview-content">
      <div class="p-message-preview-content__title">{{ title }}</div>
      <div class="p-message-preview-content__text">{{ formatText }}</div>
      <div class="p-message-preview-content__link"><a :href="url" target="_blank" style="color: #ccc;">{{ url }}</a></div>
    </div>
    <div v-if="hasButtonA" class="p-message-preview__btns">
      <a
        v-if="actionButtonTextA"
        :href="actionButtonUrlA"
        target="_blank"
        class="c-btn c-btn--preview-desktop u-w50p u-h36"
      >
        <p class="c-btn__text">{{ actionButtonTextA }}</p>
      </a>
      <a
        v-if="actionButtonTextB"
        :href="actionButtonUrlB"
        target="_blank"
        class="c-btn c-btn--preview-desktop u-w50p u-h36"
      >
        <p class="c-btn__text">{{ actionButtonTextB }}</p>
      </a>
    </div>
    <div v-else class="p-message-preview__btns"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    url: String,
    iconUrl: String,
    largeImageUrl: String,
    hasButtonA: Boolean,
    hasButtonB: Boolean,
    actionButtonTextA: String,
    actionButtonUrlA: String,
    actionButtonTextB: String,
    actionButtonUrlB: String,
  },
  computed: {
    formatText: function() {
      if (!this.text) return '';
      const len = 68;
      return this.text.length <= len ? this.text : (this.text.substr(0, len) + "...");
    }
  },
  methods: {
  }
};
</script>
